import Vue from 'vue';
import VueI18n from 'vue-i18n';
import defaultLocale from './locales/en-US.json';
import axios from 'axios';
import { Quasar } from 'quasar';
import { compass } from '@resclick/compass';

const LocalStorage = window.localStorage;

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US',
  messages: {
    'en-US': defaultLocale,
  }, // set locale messages
});

const loadedLanguages = ['en-US']; // our default language that is preloaded

function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  (document.querySelector('html') as HTMLElement).setAttribute('lang', lang);
  compass.setLanguage(lang);
  return lang;
}

export function loadLanguageAsync(lang: string) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}`).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}

export async function setLanguage(lang: string) {
  const quasarLanguageMap: any = {
    'en-US': 'en-us',
    'tr-TR': 'tr',
    'de-DE': 'de',
    'es-ES': 'es',
    'fr-FR': 'fr',
    'it-IT': 'it',
    'pl-PL': 'pl',
    'pt-PT': 'pt',
    'ru-RU': 'ru',
    'zh-HK': 'zh-hans',
  };

  const quasarLanguage = quasarLanguageMap[lang];

  loadLanguageAsync(lang).then(() => {
    i18n.locale = lang;
    (document.querySelector('html') as HTMLElement).setAttribute('lang', lang);
  });
  import(
    /* webpackInclude: /(tr|en-us|de|es|fr|it|pl|pt|ru|zh-hans)\.js$/ */
    'quasar/lang/' + quasarLanguage
  ).then((lang) => Quasar.lang.set(lang.default));
}

const storage = LocalStorage.getItem('vuex') as string;
const { preferences = {} } = storage ? JSON.parse(storage)?.user : {};

if (preferences?.locale) {
  setLanguage(preferences.locale);
}
